var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEsgNoMessages(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 250 250",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 172.76,
    y1: -149.77,
    x2: 172.76,
    y2: -238.25,
    gradientTransform: "matrix(1 0 0 -1 0 -91.33)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b0bacc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969eae"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 144.07,
    y1: -204.77,
    x2: 99.74,
    y2: -206.84,
    gradientTransform: "matrix(1 0 0 -1 0 -91.33)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#42465a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#575e84",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("style", null, "\n            .cls-2{isolation:isolate}.cls-5{fill:#eaeef9}.cls-14{fill:#ced7e2}.cls-16{fill:#dae2eb}.cls-17{fill:#d5dae8}.cls-2{fill:#062c78;opacity:.1}\n        "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M241.82 131.05c0 39.16-21.73 74.01-52.28 91.44 0 0-.21.22-.43.22-3.87 2.37-8.82 4.52-10.97 5.59h-.22c-1.72.64-12.05 4.95-13.77 4.95-.22 0-.43 0-.43.21-.22 0-.43 0-.65.22-4.52 1.29-10.97 2.37-12.26 2.58 0 .65-19.79 2.58-36.57-1.08-2.15 0-15.92-3.66-27.97-9.68-33.99-17.64-57.44-53.36-57.44-94.45 0-58.73 47.76-106.28 106.5-106.28s106.5 47.55 106.5 106.28Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M167.6 174.51v57.87c-.22 0-3.01 1.08-3.23 1.08s-.43 0-.43.22c-.22 0-.43 0-.65.21-4.52 1.29-10.97 2.37-12.26 2.58v-61.96h16.57Z",
    style: {
      fill: "#4988fd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.6 174.51v57.87c-.22 0-3.01 1.08-3.23 1.08s-.43 0-.43.22c-.22 0-.43 0-.65.21-4.52 1.29-10.97 2.37-12.26 2.58v-61.96h16.57Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.66 174.51v51.85c-1.08.64-3.01 1.29-4.52 2.15h-.22c-2.8 1.29-6.02 2.58-11.62 4.3v-58.09h16.35v-.22Z",
    style: {
      fill: "#2767f4"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M182.66 174.51v51.85c-1.08.64-3.01 1.29-4.52 2.15h-.22c-2.8 1.29-6.02 2.58-11.62 4.3v-58.09h16.35v-.22Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M182.66 196.89v25.82c-2.15 1.08-3.87 1.94-3.87 1.94h-.22c-3.66 1.94-9.25 3.66-11.62 4.3-.22 0-.43.22-.65.22v-5.59c2.58-7.75 6.88-15.71 12.69-22.38a35.19 35.19 0 0 1 3.66-4.3ZM182.66 174.51h-31.63v18.29h31.63v-18.29Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M250 109.54v65.83h-51.42v.22H95.52V57.26h97.89c1.29-.22 2.58-.22 4.09-.22 1.72 0 3.23 0 4.95.22 2.15.22 4.09.43 6.02.86 10.11 2.15 19.15 7.32 26.03 14.2 9.68 9.68 15.49 22.81 15.49 37.22Z",
    style: {
      fill: "url(#linear-gradient)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.21 127.61c6.45 0 11.83-5.16 11.83-11.83s-5.38-11.83-11.83-11.83-11.83 5.16-11.83 11.83 5.16 11.83 11.83 11.83Z",
    style: {
      fill: "#737c90"
    }
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M232.14 126.1c6.67 0 12.26-5.16 12.26-11.83s-5.38-11.83-12.26-11.83-12.26 5.16-12.26 11.83 5.38 11.83 12.26 11.83Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M232.79 126.1c6.45 0 11.83-5.16 11.83-11.83s-5.38-11.83-11.83-11.83-11.83 5.16-11.83 11.83 5.16 11.83 11.83 11.83Z",
    style: {
      fill: "#f5f7fb"
    }
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M232.79 118.79c2.58 0 4.52-1.94 4.52-4.52s-1.94-4.52-4.52-4.52-4.52 1.94-4.52 4.52 1.94 4.52 4.52 4.52Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M146.73 104.37v71.21H41.74v-71.21c0-22.38 15.92-41.31 36.79-46.04 3.44-.86 6.88-1.08 10.54-1.08h10.76c23.67 0 43.03 17.21 46.69 39.8 0 2.15.22 4.73.22 7.32Z",
    style: {
      fill: "#737c91"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m146.73 114.92-.65-17.21c-3.66-22.59-23.24-39.8-46.69-39.8H88.63c-3.66 0-7.1.43-10.54 1.08l-1.29 1.08 26.46 109.08 43.03 2.37.43-56.58Z",
    style: {
      isolation: "isolate",
      fill: "url(#linear-gradient-2)",
      opacity: 0.7
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.51 97.06c-3.66-22.59-23.24-39.8-46.69-39.8H89.06c-3.66 0-7.1.22-10.54 1.08-21.08 4.73-36.79 23.45-36.79 46.04v71.21h104.99v-71.21c0-2.58-.22-5.16-.22-7.32Zm-4.09 74.23H46.04v-66.91c0-19.79 13.98-37.44 33.56-41.74 2.8-.65 5.59-.86 9.47-.86h10.76c21.08 0 38.94 15.06 42.38 35.93v73.58h.22Z",
    style: {
      fill: "#c3cad6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.2 215.82c-3.01 4.52-6.67 11.83-8.82 17.86-.22.43-.43 1.08-.43 1.51-1.51-.21-3.01-.64-4.52-1.08-1.29-3.01-2.15-6.24-2.15-6.24.86-1.08 1.51-1.94 2.37-2.8 4.09-4.95 8.39-8.39 13.55-9.25Z",
    style: {
      fill: "#c1c8d7"
    }
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M114.24 235.4c-.43 0-.86-.21-1.29-.21-1.51-.21-3.01-.64-4.52-1.08-1.08-.22-1.94-.65-3.01-.86-.43-.22-.86-.22-1.29-.43-.43-.22-.86-.22-1.51-.43-5.59-1.72-10.97-4.09-16.14-6.67-5.38-9.03-8.39-20.01-13.55-35.28q0-.22-.22-.43s.43 0 1.51.43c.65.43 1.72.86 3.01 1.72 2.58 1.72 6.67 4.73 12.69 9.68 7.53 6.24 13.98 15.49 18.5 23.02 1.94 3.44 3.66 6.46 4.95 8.82.43.43.65 1.08.86 1.72Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M105.42 233.03c-.43-.21-.86-.21-1.29-.43-.43-.21-.86-.21-1.51-.43-9.9-19.8-21.08-32.49-27.54-39.8-.65-.86-1.29-1.51-1.94-2.15q0-.22-.22-.43s.43 0 1.51.43c.65.43 1.72.86 3.01 1.72 6.67 7.75 18.07 20.87 27.97 41.09Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M205.9 186.78s-.22.43-.65 1.29c-2.58 4.73-11.19 20.44-15.27 34.21-.22 0-.22.21-.43.21 0 0-.21.22-.43.22-3.87 2.37-8.82 4.52-10.97 5.59h-.22c-6.45 3.01-13.34 4.95-13.77 4.95 3.23-10.54 7.96-20.01 14.63-27.97 1.29-1.51 2.58-3.01 3.87-4.3.22-.21.43-.43.64-.64 5.6-5.59 11.4-9.25 17-11.62.65-.22 1.29-.65 1.94-.86.64-.43 1.72-.65 2.8-1.08.43.22.64 0 .86 0Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M205.68 186.35s-.21.22-.43.86c0 .22-.21.22-.21.43-11.19 9.9-20.01 26.46-25.6 40.23-.43.22-.86.43-1.29.65h-.22c-.43.21-1.08.43-1.51.64.22-.43.43-.64.43-.64 2.8-6.88 10.33-26.46 23.45-39.59l1.29-1.29c1.51-.43 2.8-.86 4.09-1.29Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M147.38 168.06v7.53H3.87c-2.15 0-3.87-1.72-3.87-3.66 0-2.15 1.72-3.87 3.87-3.87h143.5Z",
    style: {
      fill: "#919aac"
    }
  }), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M176.85 111.26h56.58c1.72 0 3.01 1.29 3.01 3.01s-1.29 3.01-3.01 3.01h-56.58v-6.02Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M174.91 82.43c.65-.86 2.15-.43 2.15.86v34.21h-23.24V83.29a1.24 1.24 0 0 1 2.15-.86l7.53 9.04a2.645 2.645 0 0 0 4.09 0l7.32-9.04Z",
    style: {
      fill: "#f8f9fc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.88 34.02c-2.8 13.12-4.3 26.46-4.52 39.8-.22 12.26-.22 25.82 3.44 37.65 4.52 15.06 18.5 30.12 35.71 25.6 9.47-2.58 17.21-10.76 19.36-20.87 1.29-6.45-.65-13.98-5.81-17.86-5.59-3.66-13.77-2.8-18.72 1.72-5.38 4.52-7.53 11.4-7.32 18.07.22 6.67 2.8 13.12 5.81 18.93 9.04 16.57 55.94 7.75 90.79 3.66",
    style: {
      fill: "none",
      stroke: "#c9d4e2",
      strokeDasharray: "0 0 4 4",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M7.1 23.26c1.08 4.3 5.81 5.81 10.54 3.23 5.16-2.58 8.61-4.3 7.53-8.39-1.08-3.87-5.81-4.3-11.19-4.73-6.67-.65-7.96 5.59-6.88 9.9ZM44.75 27.14c-1.72 3.66-7.32 5.81-11.19 2.15-4.3-3.87-7.53-6.45-5.81-10.54 1.72-3.66 5.16-2.58 11.62-1.51 5.38 1.29 7.53 6.02 5.38 9.9Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M27.54 12.72c-2.8-.43-5.38 1.08-6.24 3.66-.22.65-.65 1.72-.65 2.8-.65 5.38 1.08 10.11 4.3 10.54 3.23.43 6.45-3.66 7.32-8.61v-3.66c-.22-2.58-2.15-4.3-4.73-4.73-.22 0 0 0 0 0Z",
    style: {
      fill: "#989fb0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.12 175.59h-2.58c1.08 2.58 1.72 6.67 2.15 11.62-3.01.65-8.61-.22-12.05-2.8-1.08-3.87-1.94-6.88-2.8-8.82h-2.8c.65 1.08 1.72 4.52 3.01 9.47-4.73 4.52-7.75 2.8-17-1.72-.86-.43-1.94-1.08-3.23-1.51-2.15-2.58-3.87-4.73-5.59-6.24h-4.09c1.72 1.08 4.09 3.23 6.67 6.24-13.55 10.33-25.82 5.81-32.49 3.44-1.08-.43-1.94-.65-2.8-.86-7.32-3.87-13.98-6.88-19.58-8.82h-8.61v.22c10.54 1.72 35.28 14.41 57.44 28.83v.22h.22c16.78 10.97 32.06 23.02 37.87 31.84l2.15-.21v.21-.21c.43 0 1.08-.22 1.51-.22s.86-.21 1.08-.21c-.43-1.94-1.94-9.68-3.87-19.15 1.08.65 2.37 1.29 4.09 1.29h1.08c-.22 6.88-.43 13.34-.86 18.07.86-.21 1.72-.21 2.58-.43.65-10.76 2.58-47.12-1.51-60.24Zm-.43 14.2c.22 3.23.43 6.67.43 10.11-2.8 1.29-4.52-.21-7.1-3.01-.86-1.08-1.94-2.15-3.01-2.8-.43-2.15-1.08-4.09-1.51-6.02 3.44 1.51 7.96 2.15 11.19 1.72Zm-11.62 7.96c.86 4.09 1.94 8.61 2.8 13.12-.65 0-1.08.43-1.51.64-.86.65-2.15 1.29-5.16.43-1.08-1.94-2.15-3.87-3.23-5.59-1.29-2.37-2.8-4.52-3.87-6.45 4.95.22 8.18-.43 10.97-2.15Zm-2.37-9.9c.65 2.15 1.08 4.52 1.72 7.1-2.37 1.94-5.38 2.8-12.05 1.94-2.58-3.87-4.95-7.53-7.1-10.54 7.75 3.87 12.05 5.81 17.43 1.51Zm-48.19 2.58c1.94.43 3.87.65 6.02.65 6.02 0 12.69-1.72 19.79-7.1 3.01 3.87 6.24 8.61 9.47 13.77-3.87 3.66-10.33 4.09-15.92 4.52-6.45-4.3-13.12-8.17-19.36-11.83Zm22.81 13.98c4.95-.43 10.33-1.29 13.77-4.52 2.58 4.09 5.16 8.61 7.75 12.91-1.08 2.15-3.23 2.58-7.96 1.51-4.09-3.44-8.82-6.67-13.55-9.9Zm17.86 12.91c1.94 0 3.87-.43 5.38-2.15 2.8 4.95 5.59 9.9 7.75 13.77-3.66-3.66-8.18-7.53-13.12-11.62Zm16.78 13.77c-2.37-4.52-5.59-10.54-9.04-16.35 2.37.21 3.66-.65 4.73-1.08.22 0 .22-.21.43-.21 0 0 .22.21.43.43 1.29 5.81 2.37 11.83 3.44 17.21Zm4.95-15.92c-2.37.65-4.3-.64-6.02-2.37-.86-4.73-1.94-9.47-3.01-14.2l.22.22c2.15 2.37 4.95 5.16 9.04 4.09 0 3.87 0 8.18-.22 12.26Z",
    style: {
      fill: "#b4bdcf"
    }
  }), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M225.95 211.24a7.571 7.571 0 0 0 0-15.14 7.571 7.571 0 0 0 0 15.14ZM211.94 50.19a5.17 5.17 0 1 0-5.17-5.17c0 2.85 2.32 5.17 5.17 5.17ZM16.92 208.83c5.31 0 9.61-4.3 9.61-9.61s-4.3-9.61-9.61-9.61-9.61 4.3-9.61 9.61 4.3 9.61 9.61 9.61Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEsgNoMessages);
export default __webpack_public_path__ + "static/media/esg_no-messages.063d5ee792d86d8ea11d43b6d3eb9784.svg";
export { ForwardRef as ReactComponent };